import { render } from "./DownloadData.vue?vue&type=template&id=94aba5ea"
import script from "./DownloadData.vue?vue&type=script&lang=js"
export * from "./DownloadData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__